
export const catNipNav = [
    {url: '/catnip', label: 'CatNip Management', key: 'catnip.index', permissions: []},
]